import { render, staticRenderFns } from "./SendTestMessage.vue?vue&type=template&id=386b4998"
import script from "./SendTestMessage.vue?vue&type=script&lang=js"
export * from "./SendTestMessage.vue?vue&type=script&lang=js"
import style0 from "./SendTestMessage.vue?vue&type=style&index=0&id=386b4998&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports